import { useMediaQuery } from 'react-responsive';
import { defaultBreakpoints } from 'style-utils/responsive-utils/media/media';
/**
 * Returns 'true' if the viewport is at least as big as the breakpoint
 * we label 'desktop'.
 */
export function useIsAtLeastDesktopBreakpoint() {
  return useMediaQuery({ minWidth: defaultBreakpoints.desktop });
}
export function useIsAtleastTabletBreakpoint() {
  return useMediaQuery({ minWidth: defaultBreakpoints.tablet });
}
